"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7583],{

/***/ 56081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53893);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  pointer-events: ",
        ";\n\n  .page-btn {\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #eee;\n    border: none;\n    border-radius: 5px;\n    color: black;\n    svg {\n      fill: black;\n      width: 16px;\n      height: 16px;\n    }\n    &:disabled {\n      cursor: default;\n      color: white;\n      svg {\n        fill: white;\n      }\n    }\n  }\n  .page-list {\n    display: flex;\n    & > .page {\n      cursor: pointer;\n      border: none;\n      background: none;\n      padding: 10px;\n      color: #bbbbbb;\n      &[data-active='true'] {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Pagination = function(param) {
    var _type = param.type, type = _type === void 0 ? "query" : _type, className = param.className, _totalCount = param.totalCount, totalCount = _totalCount === void 0 ? 1 : _totalCount, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 1 : _pageSize, _stepSize = param.stepSize, stepSize = _stepSize === void 0 ? 10 : _stepSize, onChange = param.onChange, _value = param.value, value = _value === void 0 ? 1 : _value, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _scrollTop = param.scrollTop, scrollTop = _scrollTop === void 0 ? false : _scrollTop;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), pageState = ref[0], setPageState = ref[1];
    var currentPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (type === "value") {
            return pageState;
        } else {
            return router.query.page ? +router.query.page : 1;
        }
    }, [
        pageState,
        router.query.page
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), step = ref1[0], setStep = ref1[1];
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        setPageState(value);
        setStep(Math.ceil(value / stepSize));
    }, [
        value
    ]);
    var totalPage = Math.ceil(totalCount / pageSize);
    var stepArr = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var firstStepNumber = step * stepSize - stepSize + 1;
        var stepArr = [];
        for(var i = 0; i < stepSize; i++){
            if (firstStepNumber + i <= totalPage) stepArr.push(firstStepNumber + i);
        }
        return stepArr;
    }, [
        step,
        stepSize,
        totalPage
    ]);
    var addPage = function(page) {
        if (type === "value") {
            setPageState(page);
        }
        onChange && onChange(page);
    };
    var handleNextBtn = function() {
        setStep(function(prev) {
            return prev + 1;
        });
        addPage(step * stepSize + 1);
    };
    var handlePrevBtn = function() {
        setStep(function(prev) {
            return prev - 1;
        });
        addPage((step - 1) * stepSize - stepSize + 1);
    };
    var hasPrevStep = stepArr[0] > 1;
    var hasNextStep = stepArr[stepSize - 1] < totalPage;
    if (totalCount === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        isDisabled: isDisabled,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                className: "page-btn",
                disabled: !hasPrevStep,
                onClick: handlePrevBtn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowLeft */ .Xd, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "page-list",
                children: stepArr.map(function(page) {
                    return type === "value" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "page",
                        "data-active": page === currentPage,
                        onClick: function() {
                            return addPage(page);
                        },
                        children: page
                    }, page) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: {
                            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, router.query), {
                                page: page
                            })
                        },
                        scroll: scrollTop,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "page",
                            "data-active": page === currentPage,
                            onClick: function() {
                                return addPage(page);
                            },
                            children: page
                        })
                    }, page);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                className: "page-btn",
                disabled: !hasNextStep,
                onClick: handleNextBtn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowRight */ .ol, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Pagination__StyledWrapper",
    componentId: "sc-536a0af6-0"
})(_templateObject(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "none" : "auto";
});


/***/ }),

/***/ 20727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                width: ",
        ";\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  height: 50px;\n\n  a {\n    border: 1px solid #dddddd;\n    border-right: none;\n    box-sizing: border-box;\n    flex: 1;\n\n    &:last-child {\n      border-right: 1px solid #dddddd;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  font-size: 16px;\n\n  &[data-active='true'] {\n    border: 1px solid #01a0ff;\n    color: #01a0ff;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var CardTabs = function(param) {
    var data = param.data, initialTab = param.initialTab, _queryKey = param.queryKey, queryKey = _queryKey === void 0 ? "tab" : _queryKey, className = param.className, onChange = param.onChange, _type = param.type, type = _type === void 0 ? "query" : _type, value = param.value;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var selectedTab = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        // query 타입일 때 선택된 탭의 이름
        var selectedTabName = type === "query" ? "".concat(router.query[queryKey]) : null;
        // 선택된 탭 찾기
        var findSelectedTab = function(tab) {
            if (type === "query" && tab.selectedList) {
                // query 타입이면서 selectedList가 있는 경우
                return tab.selectedList.includes(selectedTabName);
            }
            if (type === "query") {
                var ref;
                // query 타입이면서 selectedList가 없는 경우
                return ((ref = tab.href) === null || ref === void 0 ? void 0 : ref.query[queryKey]) === selectedTabName;
            }
            if (type === "value") {
                // value 타입
                return tab.value === value;
            }
            return false;
        };
        // 데이터 배열에서 선택된 탭 찾기
        var selectedTab = data.find(findSelectedTab);
        // 선택된 탭이 없으면 초기 탭 반환
        return selectedTab || initialTab;
    }, [
        type,
        value,
        router,
        queryKey,
        data,
        initialTab
    ]);
    var handleClick = function(tab) {
        if (type === "query") {
            var ref;
            router.push({
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router.query, (ref = tab.href) === null || ref === void 0 ? void 0 : ref.query)
            });
        }
        onChange && onChange(tab);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: data.map(function(tab, idx) {
            var ref;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: type === "query" ? {
                    query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router.query, (ref = tab.href) === null || ref === void 0 ? void 0 : ref.query)
                } : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTab, {
                        className: "tab",
                        onClick: function() {
                            return handleClick(tab);
                        },
                        customCss: (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), tab.size),
                        "data-active": (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) === tab.id,
                        children: [
                            tab.name,
                            " ",
                            tab.count !== undefined && "(".concat(tab.count || 0, ")")
                        ]
                    })
                })
            }, idx);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardTabs);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CardTabs__StyledWrapper",
    componentId: "sc-4532d037-0"
})(_templateObject1());
var StyledTab = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "CardTabs__StyledTab",
    componentId: "sc-4532d037-1"
})(_templateObject2(), function(param) {
    var customCss = param.customCss;
    return customCss;
});


/***/ }),

/***/ 4210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screen_ScreenNotificationPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/gql/updator/removeAllScrap.ts



// import {
//   DeleteAllNotificationMutation,
//   GqlNotificationListDocument,
//   GqlNotificationListQuery,
//   GqlNotificationListQueryVariables,
// } from 'generated/graphql'
var removeAllScrapUpdator = function(variables) {
    return function(cache) {
        // delete data
        var cachedNotifications = cache.readQuery({
            query: graphql/* GqlNotificationListDocument */.pW_,
            variables: variables
        });
        if (!cachedNotifications || !cachedNotifications.viewerNotifications) return;
        cache.writeQuery({
            query: graphql/* GqlNotificationListDocument */.pW_,
            variables: variables,
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedNotifications), {
                viewerNotifications: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedNotifications.viewerNotifications), {
                    nodes: []
                })
            })
        });
    };
};
/* harmony default export */ var removeAllScrap = (removeAllScrapUpdator);

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/gql/updator/removeScrap.ts



var deleteNotificationUpdater = function(variables) {
    return function(cache, mutationResult) {
        // delete data
        var cachedNotifications = cache.readQuery({
            query: graphql/* GqlNotificationListDocument */.pW_,
            variables: variables
        });
        // get deleted notification
        if (!mutationResult.data || !mutationResult.data.deleteNotification.notification) return;
        var deletedNotification = mutationResult.data.deleteNotification.notification;
        if (!cachedNotifications || !cachedNotifications.viewerNotifications) return;
        cache.writeQuery({
            query: graphql/* GqlNotificationListDocument */.pW_,
            variables: variables,
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedNotifications), {
                viewerNotifications: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedNotifications.viewerNotifications), {
                    nodes: cachedNotifications.viewerNotifications.nodes.filter(function(notification) {
                        return (notification === null || notification === void 0 ? void 0 : notification.id) !== deletedNotification.id;
                    })
                })
            })
        });
    // count data
    // refetchScreen()
    };
};
/* harmony default export */ var removeScrap = (deleteNotificationUpdater);

// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/hooks/useFlutterInappwebview.ts
var useFlutterInappwebview = __webpack_require__(2165);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/Pagination/Pagination.tsx
var Pagination = __webpack_require__(56081);
// EXTERNAL MODULE: ./src/app.components/tabs/CardTabs/CardTabs.tsx
var CardTabs = __webpack_require__(20727);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./src/app.components/modals/ChatAppModal/ChatAppModal.tsx + 1 modules
var ChatAppModal = __webpack_require__(9466);
;// CONCATENATED MODULE: ./src/svgIcons/notification/Bell.tsx

function Bell() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40.506",
        height: "40.506",
        viewBox: "0 0 40.506 40.506",
        "aria-label": "알림",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "알림"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "b1cs8nqwfa",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        stroke: "#666",
                        strokeWidth: "3",
                        d: "M0 0h40.506v40.506H0z",
                        "data-name": "사각형 9267"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "data-name": "마스크 그룹 198",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    clipPath: "url(#b1cs8nqwfa)",
                    "data-name": "그룹 11232",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#fff",
                        "data-name": "그룹 11231",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                stroke: "#ddd",
                                strokeWidth: "3",
                                "data-name": "타원 1083",
                                transform: "translate(13.967 25.343)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "6.072",
                                        cy: "6.072",
                                        r: "6.072",
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "6.072",
                                        cy: "6.072",
                                        r: "4.572",
                                        fill: "none"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                "data-name": "합치기 132",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M32.615 29.914H7.461a.606.606 0 01-.596-.613c0-.338.267-.612.596-.612h1.5V16.525a11 11 0 013.245-7.833 11.005 11.005 0 017.833-3.245c2.958 0 5.74 1.152 7.832 3.245a11.006 11.006 0 013.244 7.833v12.164h1.5c.329 0 .596.274.596.612a.606.606 0 01-.596.613z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "#ddd",
                                        d: "M29.615 28.414v-11.89c0-5.279-4.296-9.577-9.576-9.577-5.281 0-9.578 4.296-9.578 9.578v11.89h19.154m3 3H7.461A2.105 2.105 0 015.365 29.3c0-1.166.939-2.112 2.096-2.112V16.525c0-6.948 5.631-12.578 12.578-12.578 6.946 0 12.576 5.631 12.576 12.578v10.664c1.159 0 2.096.945 2.096 2.112a2.104 2.104 0 01-2.096 2.113z"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var notification_Bell = (Bell);

;// CONCATENATED MODULE: ./src/app.feature/notification/component/EmptyNotification/EmptyNotificationDescription.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 7px 0 32px;\n  .desc {\n    font-size: 12px;\n    line-height: 1.5;\n    letter-spacing: -0.48px;\n    text-align: center;\n    color: #999;\n  }\n\n  ",
        " {\n    padding: 10px 0 20px;\n    .desc {\n      font-size: 15px;\n      line-height: 1.33;\n      letter-spacing: -0.6px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var EmptyNotificationDescription = function(param) {
    var selectedTab = param.selectedTab, Tabs = param.Tabs;
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            selectedTab === Tabs.ACTIVITY && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desc",
                            children: "대외활동을 스크랩하고, 합격자료&커뮤니티에"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desc",
                            children: "글을 작성해보세요."
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desc",
                            children: "관심있는 기업의 공고를 탐색하고"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desc",
                            children: "공고를 스크랩해보세요."
                        })
                    ]
                })
            }),
            selectedTab === Tabs.CHANNEL && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "관심있는 기업채널을 탐색하고"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "채널을 팔로우해보세요."
                    })
                ]
            }),
            selectedTab === Tabs.COMMUNITY && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "지금 가장 인기있는"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "커뮤니티 글을 확인해보세요."
                    })
                ]
            }),
            selectedTab === Tabs.CHAT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "채팅방에서 궁금한 채용정보를"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "실시간으로 확인해보세요."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EmptyNotification_EmptyNotificationDescription = (EmptyNotificationDescription);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EmptyNotificationDescription__StyledWrapper",
    componentId: "sc-99c23e1c-0"
})(_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/notification/component/EmptyNotification/EmptyNotification.tsx



function EmptyNotification_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 129px 0;\n  .ico {\n    border-radius: 50%;\n    width: 64px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #efefef;\n    margin-bottom: 14px;\n  }\n  .empty-noti-desc {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.5;\n    letter-spacing: -0.64px;\n    color: #999;\n  }\n  .empty-noti-btn {\n    color: #333;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: -0.48px;\n    padding: 10px 20px 11px;\n  }\n\n  ",
        " {\n    padding: 92px 0 101px;\n    .ico {\n      width: auto;\n      height: auto;\n      background-color: #fff;\n      svg {\n        width: 78px;\n        height: 78px;\n      }\n    }\n    .empty-noti-desc {\n      color: #333;\n      font-size: 20px;\n      font-weight: 500;\n      letter-spacing: -0.8px;\n      span {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    EmptyNotification_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var Tabs = {
    ACTIVITY: "activity",
    CHANNEL: "channel",
    COMMUNITY: "community",
    CHAT: "chat"
};
var EmptyNotification = function() {
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var ref = (0,context/* useDomain */.ay)(), protocol = ref.protocol, xen = ref.xen;
    var selectedTab = (0,react.useMemo)(function() {
        return String(router.query.tab);
    }, []);
    var ref1 = (0,react.useState)(false), isAppModalOpen = ref1[0], setIsAppModalOpen = ref1[1];
    var handleClickButton = function() {
        if (selectedTab === Tabs.ACTIVITY) {
            router.push("/list/recruit");
        }
        if (selectedTab === Tabs.CHANNEL) {
            router.push("/channel");
        }
        if (selectedTab === Tabs.COMMUNITY) {
            router.push("".concat(protocol, "://").concat(xen, "/best"));
        }
        if (selectedTab === Tabs.CHAT) {
            if (isMobile) {
                isWebview ? router.push("/chat") : setIsAppModalOpen(true);
            } else {
                router.replace({
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        chatOpenType: "default"
                    })
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyNotification_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ico",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_Bell, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "empty-noti-desc",
                children: [
                    "새로운 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "알림"
                    }),
                    "이 없습니다."
                ]
            }),
            Object.values(Tabs).includes(selectedTab) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotification_EmptyNotificationDescription, {
                        selectedTab: selectedTab,
                        Tabs: Tabs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        className: "empty-noti-btn",
                        color: "lightGrey",
                        onClick: handleClickButton,
                        children: [
                            selectedTab === Tabs.ACTIVITY && "채용공고 보기",
                            selectedTab === Tabs.CHANNEL && "채널 보기",
                            selectedTab === Tabs.COMMUNITY && "베스트 인기글 보기",
                            selectedTab === Tabs.CHAT && "채팅방 바로가기"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatAppModal/* default */.Z, {
                open: isAppModalOpen,
                onClose: function() {
                    return setIsAppModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var EmptyNotification_EmptyNotification = (EmptyNotification);
var EmptyNotification_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EmptyNotification__StyledWrapper",
    componentId: "sc-671158fc-0"
})(EmptyNotification_templateObject(), media/* mobileBreakPoint */.vm);

// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.modules/util/time.tsx
var time = __webpack_require__(20178);
;// CONCATENATED MODULE: ./src/svgIcons/MentorApproveIcon.tsx



var MentorApproveIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "멘토 승인 아이콘"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_979_108)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M29.9009 19.032C29.6514 18.7806 29.4705 18.4694 29.3756 18.1282C29.2807 17.7869 29.275 17.4271 29.3589 17.083L29.3749 17.017C29.5028 16.4927 29.4209 15.9393 29.1467 15.4745C28.8725 15.0098 28.4276 14.6705 27.9069 14.529C27.5651 14.436 27.2529 14.257 27 14.0089C26.7472 13.7608 26.5623 13.452 26.4629 13.112L26.4439 13.047C26.2926 12.529 25.945 12.0907 25.4753 11.8252C25.0055 11.5598 24.4507 11.4883 23.9289 11.626C23.5865 11.7164 23.2265 11.7175 22.8835 11.6291C22.5405 11.5407 22.226 11.3657 21.9699 11.121L21.9219 11.074C21.532 10.7008 21.0118 10.4947 20.4721 10.4996C19.9325 10.5045 19.4161 10.7199 19.0329 11.1C18.7816 11.3495 18.4704 11.5304 18.1292 11.6253C17.7879 11.7202 17.428 11.7259 17.0839 11.642L17.0179 11.626C16.4937 11.4981 15.9403 11.58 15.4755 11.8542C15.0108 12.1284 14.6715 12.5733 14.5299 13.094C14.437 13.4358 14.258 13.748 14.0099 14.0009C13.7618 14.2537 13.4529 14.4386 13.1129 14.538L13.0479 14.557C12.53 14.7083 12.0916 15.0558 11.8262 15.5256C11.5608 15.9954 11.4893 16.5502 11.6269 17.072C11.7173 17.4145 11.7182 17.7745 11.6296 18.1175C11.541 18.4605 11.3659 18.775 11.1209 19.031L11.0749 19.08C10.7018 19.4699 10.4957 19.9901 10.5006 20.5297C10.5054 21.0694 10.7209 21.5858 11.1009 21.969C11.3505 22.2203 11.5313 22.5315 11.6262 22.8727C11.7211 23.214 11.7269 23.5739 11.6429 23.918L11.6269 23.984C11.4991 24.5082 11.581 25.0616 11.8552 25.5264C12.1294 25.9911 12.5742 26.3304 13.0949 26.472C13.4368 26.5649 13.749 26.7439 14.0018 26.992C14.2547 27.2401 14.4396 27.549 14.5389 27.889L14.5579 27.954C14.7093 28.4719 15.0568 28.9102 15.5266 29.1757C15.9964 29.4411 16.5512 29.5126 17.0729 29.375C17.4154 29.2845 17.7753 29.2834 18.1183 29.3718C18.4613 29.4603 18.7759 29.6352 19.0319 29.88L19.0809 29.927C19.471 30.2999 19.9913 30.5059 20.5309 30.5008C21.0706 30.4958 21.5869 30.2802 21.9699 29.9C22.2213 29.6504 22.5325 29.4696 22.8737 29.3747C23.215 29.2798 23.5748 29.274 23.9189 29.358L23.9849 29.374C24.5092 29.5018 25.0626 29.4199 25.5273 29.1457C25.9921 28.8715 26.3314 28.4267 26.4729 27.906C26.5658 27.5641 26.7449 27.2519 26.993 26.9991C27.2411 26.7462 27.5499 26.5613 27.8899 26.462L27.9549 26.443C28.4729 26.2916 28.9112 25.9441 29.1766 25.4743C29.4421 25.0045 29.5136 24.4497 29.3759 23.928C29.2855 23.5855 29.2844 23.2256 29.3728 22.8826C29.4612 22.5396 29.6362 22.225 29.8809 21.969L29.9279 21.92C30.3006 21.53 30.5064 21.0099 30.5013 20.4705C30.4963 19.9311 30.2809 19.4149 29.9009 19.032Z",
                        fill: "#01A0FF",
                        stroke: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.814 20.8767L19.86 23.5297L24.188 17.4688",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_979_108",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var svgIcons_MentorApproveIcon = (MentorApproveIcon);

;// CONCATENATED MODULE: ./src/svgIcons/notification/ActivityType.tsx

function ActivityType() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "공고 알림"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1011_154)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27 11.5H14C12.3431 11.5 11 12.8431 11 14.5V27C11 28.6569 12.3431 30 14 30H27C28.6569 30 30 28.6569 30 27V14.5C30 12.8431 28.6569 11.5 27 11.5Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27 12.25H14C12.7574 12.25 11.75 13.2574 11.75 14.5V27C11.75 28.2426 12.7574 29.25 14 29.25H27C28.2426 29.25 29.25 28.2426 29.25 27V14.5C29.25 13.2574 28.2426 12.25 27 12.25Z",
                        stroke: "#01A0FF",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.3442 22.0371L20.2021 25.126L24.4932 20.1909",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.7134 16.939H30.3613Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.7134 16.939H30.3613",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18 10.5C18 9.94772 17.5523 9.5 17 9.5C16.4477 9.5 16 9.94772 16 10.5V13.5C16 14.0523 16.4477 14.5 17 14.5C17.5523 14.5 18 14.0523 18 13.5V10.5Z",
                        fill: "#01A0FF",
                        stroke: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M25 10.5C25 9.94772 24.5523 9.5 24 9.5C23.4477 9.5 23 9.94772 23 10.5V13.5C23 14.0523 23.4477 14.5 24 14.5C24.5523 14.5 25 14.0523 25 13.5V10.5Z",
                        fill: "#01A0FF",
                        stroke: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1011_154",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var notification_ActivityType = (ActivityType);

;// CONCATENATED MODULE: ./src/svgIcons/notification/ChannelType.tsx

function ChannelType() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "채널 알림"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1011_140)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 0.5C24.4556 0.5 28.3224 1.67298 31.6114 3.87061C34.9004 6.06824 37.4638 9.19181 38.9776 12.8463C40.4913 16.5009 40.8874 20.5222 40.1157 24.4018C39.344 28.2814 37.4392 31.8451 34.6421 34.6421C31.8451 37.4392 28.2814 39.344 24.4018 40.1157C20.5222 40.8874 16.5009 40.4913 12.8463 38.9776C9.19181 37.4638 6.06824 34.9004 3.87061 31.6114C1.67298 28.3224 0.5 24.4556 0.5 20.5C0.5 15.1957 2.60714 10.1086 6.35786 6.35786C10.1086 2.60714 15.1957 0.5 20.5 0.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.7962 10.5H14.6702C14.0874 10.5079 13.5315 10.7468 13.1247 11.1641C12.7178 11.5815 12.4932 12.1432 12.5002 12.726V28.274C12.4932 28.8568 12.7178 29.4185 13.1247 29.8359C13.5315 30.2532 14.0874 30.4921 14.6702 30.5H27.2922C27.8749 30.4921 28.4308 30.2532 28.8376 29.8359C29.2445 29.4185 29.4691 28.8568 29.4622 28.274V19.483C29.4622 19.317 29.5462 16.218 29.4622 16.077L24.5502 10.936C24.4732 10.8041 24.3632 10.6945 24.231 10.618C24.0987 10.5416 23.9489 10.5009 23.7962 10.5Z",
                        fill: "#01A0FF",
                        stroke: "#01A0FF",
                        strokeWidth: "1.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.7744 11.0303V16.5132H29.2173",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.4976 27.0552H25.4976",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.4976 24.144H25.4976",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.4966 21.2002H25.4966",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.5 14.521H16.5C16.3619 14.521 16.25 14.6329 16.25 14.771V17.771C16.25 17.9091 16.3619 18.021 16.5 18.021H19.5C19.6381 18.021 19.75 17.9091 19.75 17.771V14.771C19.75 14.6329 19.6381 14.521 19.5 14.521Z",
                        stroke: "white",
                        strokeWidth: "1.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1011_140",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var notification_ChannelType = (ChannelType);

;// CONCATENATED MODULE: ./src/svgIcons/notification/ChatReplyMessageType.tsx

var ChatReplyMessageType = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "채팅 답글 알림"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "g0q1958yea",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        stroke: "#707070",
                        strokeWidth: "1.5",
                        d: "M379 637.164h20v20h-20z",
                        "data-name": "사각형 21620"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "data-name": "구성 요소 292 – 114",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    "data-name": "그룹 29886",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            stroke: "#eee",
                            d: "M20.5.5a20 20 0 11-20 20 20 20 0 0120-20z",
                            "data-name": "패스 12611"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            clipPath: "url(#g0q1958yea)",
                            "data-name": "마스크 그룹 4534",
                            transform: "translate(-368.5 -626.664)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                "data-name": "그룹 29884",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    "data-name": "그룹 29883",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            "data-name": "그룹 29877",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                    "data-name": "그룹 29876",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        fill: "#01a0ff",
                                                        "data-name": "합치기 222",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M386.976 652.084a6.305 6.305 0 01-3.966-1.383l-.272-.217-.342.068-1.34.267a.249.249 0 01-.246-.091.241.241 0 01-.046-.212l.417-1.77.057-.244-.1-.23a6.38 6.38 0 015.837-8.934 6.38 6.38 0 016.373 6.374 6.38 6.38 0 01-6.373 6.372z"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M386.976 651.334a5.63 5.63 0 005.623-5.622 5.63 5.63 0 00-5.623-5.624 5.63 5.63 0 00-5.152 7.882l.202.46-.354 1.501 1.26-.25.545.433a5.563 5.563 0 003.499 1.22m0 1.5a7.093 7.093 0 01-4.434-1.546l-1.341.267a1 1 0 01-1.168-1.21l.417-1.77a7.123 7.123 0 116.525 4.26z"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "none",
                                                    stroke: "#01a0ff",
                                                    strokeLinecap: "round",
                                                    strokeWidth: "1.5",
                                                    d: "M383.923 645.451h6.106",
                                                    "data-name": "선 2044"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "none",
                                                    stroke: "#01a0ff",
                                                    strokeLinecap: "round",
                                                    strokeWidth: "1.5",
                                                    d: "M383.923 647.486h4.071",
                                                    "data-name": "선 2045"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            "data-name": "그룹 29882",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    "data-name": "그룹 29879",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                            "data-name": "그룹 29878",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                                fill: "#fff",
                                                                "data-name": "합치기 223",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M390.507 655.269a6.93 6.93 0 01-6.922-6.921 6.929 6.929 0 016.922-6.921 6.929 6.929 0 016.921 6.92c0 1.17-.297 2.326-.858 3.342l-.147.265.079.292.73 2.721a.146.146 0 01-.025.133.123.123 0 01-.094.052c-.007 0-.015 0-.023-.002l-3.155-.523a.15.15 0 01-.023-.006l-.277-.09-.265.12a6.863 6.863 0 01-2.862.618z"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M390.507 642.177a6.178 6.178 0 00-6.172 6.17 6.179 6.179 0 008.723 5.622l.531-.241.511.166 2.164.359-.643-2.397.292-.53a6.174 6.174 0 00-5.406-9.149m0-1.5a7.672 7.672 0 016.72 11.375l.73 2.72c.168.628-.358 1.223-.99 1.118l-3.156-.523a.9.9 0 01-.132-.032 7.671 7.671 0 11-3.172-14.658z"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeWidth: "1.5",
                                                            d: "M387.037 647.163h6.303",
                                                            "data-name": "선 2046"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "none",
                                                            stroke: "#fff",
                                                            strokeLinecap: "round",
                                                            strokeWidth: "1.5",
                                                            d: "M387.037 649.297h4.202",
                                                            "data-name": "선 2047"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    "data-name": "그룹 29881",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                            "data-name": "그룹 29880",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                                fill: "#01a0ff",
                                                                "data-name": "합치기 224",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M391.408 655.231a6.38 6.38 0 01-6.374-6.373 6.38 6.38 0 016.374-6.374 6.38 6.38 0 016.373 6.374 6.368 6.368 0 01-.862 3.202l-.158.272.083.303.46 1.684a.24.24 0 01-.042.216.249.249 0 01-.24.096l-1.97-.32-.263-.044-.23.132a6.372 6.372 0 01-3.151.832z"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M391.408 643.234a5.63 5.63 0 00-5.624 5.624 5.63 5.63 0 005.624 5.623 5.62 5.62 0 002.78-.734l.46-.263 1.727.282-.42-1.54.316-.543a5.62 5.62 0 00.76-2.825 5.63 5.63 0 00-5.623-5.624m0-1.5a7.123 7.123 0 016.16 10.704l.459 1.684a1 1 0 01-1.126 1.25l-1.97-.322a7.124 7.124 0 11-3.523-13.316z"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                                                            fill: "#fff",
                                                            fontFamily: "Cafe24Ssurround,Cafe24 Ssurround",
                                                            fontSize: "9",
                                                            letterSpacing: "-.04em",
                                                            transform: "translate(391.5 651.164)",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                                                                x: "-3.033",
                                                                y: "0",
                                                                children: "A"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var notification_ChatReplyMessageType = (ChatReplyMessageType);

;// CONCATENATED MODULE: ./src/svgIcons/notification/CommentMentorPostIcon.tsx

var CommentMentorPostIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "댓글 아이콘"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_981_123)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.592 28.25L25.968 26.706L26.402 26.591C27.1471 26.3918 27.8055 25.9522 28.2753 25.3405C28.745 24.7288 28.9998 23.9792 29 23.208V16C29 14.07 27.43 12.5 25.5 12.5H15.5C13.57 12.5 12 14.07 12 16V23.208C12 25.138 13.57 26.708 15.5 26.708H23.217L24.592 28.25ZM24.592 30C24.4509 30.0003 24.3114 29.9707 24.1827 29.9132C24.0539 29.8556 23.9388 29.7713 23.845 29.666L22.545 28.208H15.5C14.1739 28.208 12.9021 27.6812 11.9645 26.7435C11.0268 25.8059 10.5 24.5341 10.5 23.208V16C10.5 14.6739 11.0268 13.4021 11.9645 12.4645C12.9021 11.5268 14.1739 11 15.5 11H25.5C26.8261 11 28.0979 11.5268 29.0355 12.4645C29.9732 13.4021 30.5 14.6739 30.5 16V23.208C30.5 24.31 30.1362 25.3811 29.465 26.255C28.7937 27.129 27.8527 27.7568 26.788 28.041L25.338 29.666C25.2443 29.7712 25.1294 29.8554 25.0008 29.913C24.8722 29.9705 24.7329 30.0002 24.592 30Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.5 11.5H14.5C12.8431 11.5 11.5 12.8431 11.5 14.5V24.5C11.5 26.1569 12.8431 27.5 14.5 27.5H26.5C28.1569 27.5 29.5 26.1569 29.5 24.5V14.5C29.5 12.8431 28.1569 11.5 26.5 11.5Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.8718 23H16.7638L19.9684 14.2727H21.0593L24.2638 23H23.1559L20.5479 15.6534H20.4798L17.8718 23ZM18.2809 19.5909H22.7468V20.5284H18.2809V19.5909Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22.7749 26.6289L24.3749 28.9529L26.2349 26.6289H22.7749Z",
                        fill: "#01A0FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_981_123",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var notification_CommentMentorPostIcon = (CommentMentorPostIcon);

;// CONCATENATED MODULE: ./src/svgIcons/notification/CommunityType.tsx

function CommunityType() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "커뮤니티 알림"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_982_135)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.337 21.4528C15.442 21.3539 15.5808 21.2988 15.725 21.2988H16.205V22.4168H15.955C13.91 24.3428 13.055 25.0528 12.604 25.0528C11.879 25.0528 11.845 24.6008 12.004 23.7368C12.067 23.3848 12.185 22.9118 12.357 22.3148C11.7689 22.1309 11.2561 21.7617 10.8952 21.2622C10.5343 20.7628 10.3448 20.1599 10.355 19.5438V15.2668C10.3281 14.3311 10.6735 13.423 11.3154 12.7417C11.9573 12.0603 12.8433 11.6616 13.779 11.6328H20.455C21.1162 11.6446 21.7603 11.8455 22.311 12.2118C22.8074 12.5489 23.2111 13.0053 23.485 13.5391C23.759 14.0729 23.8945 14.667 23.879 15.2668V16.3758H22.755V15.2678C22.7824 14.6294 22.5558 14.0061 22.1247 13.5344C21.6937 13.0626 21.0933 12.7809 20.455 12.7508H13.78C13.1417 12.7809 12.5413 13.0626 12.1102 13.5344C11.6792 14.0061 11.4526 14.6294 11.48 15.2678V19.5438C11.4596 19.9867 11.6152 20.4198 11.9129 20.7484C12.2106 21.077 12.6262 21.2745 13.069 21.2978C13.1566 21.2972 13.2431 21.3172 13.3216 21.3561C13.4 21.3951 13.4682 21.4519 13.5207 21.5221C13.5731 21.5923 13.6084 21.6738 13.6235 21.76C13.6387 21.8463 13.6334 21.935 13.608 22.0188C13.444 22.5521 13.3166 23.0018 13.226 23.3678C13.734 22.9371 14.4363 22.2985 15.333 21.4518L15.337 21.4528Z",
                        fill: "#01A0FF",
                        stroke: "#01A0FF",
                        strokeWidth: "0.3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22.144 12.5317H12.144C11.5918 12.5317 11.144 12.9795 11.144 13.5317V20.5317C11.144 21.084 11.5918 21.5317 12.144 21.5317H22.144C22.6963 21.5317 23.144 21.084 23.144 20.5317V13.5317C23.144 12.9795 22.6963 12.5317 22.144 12.5317Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.7589 21.1537C12.7589 21.1537 12.0449 24.4537 13.1959 24.0097C14.3469 23.5657 17.3629 19.3657 17.3629 19.3657L12.7589 21.1537Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.123 19.1128H19.623C19.2088 19.1128 18.873 19.4486 18.873 19.8628C18.873 20.277 19.2088 20.6128 19.623 20.6128H26.123C26.5373 20.6128 26.873 20.277 26.873 19.8628C26.873 19.4486 26.5373 19.1128 26.123 19.1128Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.123 21.9238H19.623C19.2088 21.9238 18.873 22.2596 18.873 22.6738C18.873 23.088 19.2088 23.4238 19.623 23.4238H24.123C24.5373 23.4238 24.873 23.088 24.873 22.6738C24.873 22.2596 24.5373 21.9238 24.123 21.9238Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27.3403 25.8208C27.3403 25.8208 27.9933 28.3658 26.9403 28.0208C25.8873 27.6758 23.1343 24.4438 23.1343 24.4438L27.3403 25.8208Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M25.644 14.4658H19.644C16.8826 14.4658 14.644 16.7044 14.644 19.4658V22.4658C14.644 25.2272 16.8826 27.4658 19.644 27.4658H25.644C28.4055 27.4658 30.644 25.2272 30.644 22.4658V19.4658C30.644 16.7044 28.4055 14.4658 25.644 14.4658Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.3878 26.6507C18.4316 26.6261 17.5243 26.2229 16.8652 25.5296C16.2061 24.8364 15.8491 23.9099 15.8728 22.9537V19.3377C15.8605 18.8639 15.9418 18.3924 16.1118 17.95C16.2818 17.5077 16.5374 17.1031 16.8638 16.7595C17.1902 16.4159 17.5811 16.14 18.0142 15.9475C18.4473 15.755 18.914 15.6498 19.3878 15.6377H26.4178C27.3745 15.6623 28.2823 16.0659 28.9415 16.7598C29.6007 17.4537 29.9572 18.381 29.9328 19.3377V23.7377C29.9431 24.3753 29.7421 24.9984 29.3612 25.5098C28.9802 26.0212 28.4407 26.3921 27.8268 26.5647C28.0118 27.1927 28.1388 27.6887 28.2068 28.0567C28.3588 28.8897 28.3228 29.3637 27.6618 29.3637C27.2338 29.3637 26.2938 28.5967 24.1808 26.6477H19.3878V26.6507ZM26.6878 26.2877C26.6614 26.2103 26.6534 26.1278 26.6646 26.0469C26.6757 25.9659 26.7057 25.8886 26.752 25.8213C26.7984 25.7539 26.8599 25.6983 26.9315 25.659C27.0032 25.6197 27.0831 25.5976 27.1648 25.5947C27.4025 25.5886 27.6368 25.5357 27.8541 25.4391C28.0714 25.3425 28.2676 25.204 28.4314 25.0316C28.5952 24.8591 28.7235 24.6561 28.8088 24.4341C28.8941 24.2121 28.9349 23.9755 28.9288 23.7377V19.3377C28.9457 18.6549 28.6908 17.9932 28.2202 17.4982C27.7495 17.0032 27.1016 16.7152 26.4188 16.6977H19.3888C19.0502 16.7057 18.7165 16.7804 18.4068 16.9175C18.0971 17.0545 17.8175 17.2512 17.5838 17.4964C17.3501 17.7416 17.1671 18.0304 17.0451 18.3463C16.9231 18.6622 16.8645 18.9991 16.8728 19.3377V22.9577C16.8564 23.6406 17.1116 24.302 17.5823 24.797C18.0531 25.2919 18.701 25.5799 19.3838 25.5977H24.3728C24.496 25.5981 24.6145 25.6448 24.7048 25.7287C25.5048 26.4687 26.3181 27.1907 27.1448 27.8947C27.0095 27.3527 26.8571 26.817 26.6878 26.2877Z",
                        fill: "#01A0FF",
                        stroke: "#01A0FF",
                        strokeWidth: "0.3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.1436 16.4658H19.1436C17.4867 16.4658 16.1436 17.809 16.1436 19.4658V23.4658C16.1436 25.1227 17.4867 26.4658 19.1436 26.4658H26.1436C27.8004 26.4658 29.1436 25.1227 29.1436 23.4658V19.4658C29.1436 17.809 27.8004 16.4658 26.1436 16.4658Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.1226 19.1875H19.6226C19.2083 19.1875 18.8726 19.5233 18.8726 19.9375C18.8726 20.3517 19.2083 20.6875 19.6226 20.6875H26.1226C26.5368 20.6875 26.8726 20.3517 26.8726 19.9375C26.8726 19.5233 26.5368 19.1875 26.1226 19.1875Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.1226 21.9238H19.6226C19.2083 21.9238 18.8726 22.2596 18.8726 22.6738C18.8726 23.088 19.2083 23.4238 19.6226 23.4238H24.1226C24.5368 23.4238 24.8726 23.088 24.8726 22.6738C24.8726 22.2596 24.5368 21.9238 24.1226 21.9238Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27.3398 25.8208C27.3398 25.8208 27.9928 28.3658 26.9398 28.0208C25.8868 27.6758 23.1338 24.4438 23.1338 24.4438L27.3398 25.8208Z",
                        fill: "#01A0FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_982_135",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var notification_CommunityType = (CommunityType);

;// CONCATENATED MODULE: ./src/svgIcons/notification/MentorRewardIcon.tsx

var MentorRewardIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "리워드 아이콘"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_980_116)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 10.5C22.4778 10.5 24.4112 11.0865 26.0557 12.1853C27.7002 13.2841 28.9819 14.8459 29.7388 16.6732C30.4957 18.5004 30.6937 20.5111 30.3079 22.4509C29.922 24.3907 28.9696 26.1725 27.5711 27.5711C26.1725 28.9696 24.3907 29.922 22.4509 30.3079C20.5111 30.6937 18.5004 30.4957 16.6732 29.7388C14.8459 28.9819 13.2841 27.7002 12.1853 26.0557C11.0865 24.4112 10.5 22.4778 10.5 20.5C10.5 17.8478 11.5536 15.3043 13.4289 13.4289C15.3043 11.5536 17.8478 10.5 20.5 10.5Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21.099 24.6581C20.4257 24.672 19.7539 24.5874 19.105 24.4071C18.6068 24.2661 18.1396 24.0324 17.728 23.7181C17.3737 23.4429 17.0901 23.087 16.901 22.6801C16.7147 22.2702 16.6049 21.8296 16.577 21.3801C16.5446 20.8349 16.5446 20.2883 16.577 19.7431C16.5948 19.2846 16.6993 18.8337 16.885 18.4141C17.0741 18.0001 17.3541 17.6341 17.704 17.3431C18.1106 17.0114 18.579 16.7636 19.082 16.6141C19.7311 16.4231 20.4056 16.3331 21.082 16.3471C21.6722 16.3387 22.2608 16.4097 22.832 16.5581C23.2403 16.6547 23.6297 16.8186 23.984 17.0431C24.1026 17.1105 24.2034 17.2052 24.2782 17.3192C24.353 17.4333 24.3995 17.5635 24.414 17.6991C24.4303 17.9551 24.3599 18.2091 24.214 18.4201C24.1405 18.5316 24.0406 18.6231 23.9232 18.6868C23.8058 18.7505 23.6746 18.7842 23.541 18.7851C23.2655 18.805 22.9895 18.7519 22.741 18.6311C22.579 18.5645 22.3874 18.4978 22.166 18.4311C21.8729 18.3519 21.5696 18.3165 21.266 18.3261C20.743 18.2797 20.2195 18.4088 19.778 18.6931C19.6208 18.8266 19.495 18.9931 19.4096 19.1809C19.3242 19.3686 19.2813 19.5729 19.284 19.7791C19.2516 20.2809 19.2516 20.7843 19.284 21.2861C19.2876 21.4905 19.3349 21.6917 19.4227 21.8762C19.5105 22.0608 19.6368 22.2244 19.793 22.3561C20.2329 22.6419 20.7554 22.7731 21.278 22.7291C21.6029 22.7375 21.9266 22.6881 22.234 22.5831C22.4436 22.5071 22.6492 22.4207 22.85 22.3241C23.1235 22.1807 23.4361 22.1294 23.741 22.1781C23.8713 22.2026 23.9949 22.2542 24.1038 22.3297C24.2127 22.4052 24.3044 22.5028 24.373 22.6161C24.5022 22.8096 24.5647 23.0399 24.551 23.2721C24.5452 23.3933 24.5132 23.5119 24.4573 23.6196C24.4014 23.7273 24.3228 23.8216 24.227 23.8961C23.8701 24.146 23.4685 24.3249 23.044 24.4231C22.4096 24.5903 21.7551 24.6694 21.099 24.6581Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_980_116",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var notification_MentorRewardIcon = (MentorRewardIcon);

;// CONCATENATED MODULE: ./src/svgIcons/notification/RecommendMentorPostIcon.tsx

var RecommendMentorPostIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "질문 등록 아이콘"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_983_155)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z",
                        fill: "white",
                        stroke: "#EEEEEE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.592 28.25L25.968 26.706L26.402 26.591C27.1471 26.3918 27.8055 25.9522 28.2753 25.3405C28.745 24.7288 28.9998 23.9792 29 23.208V16C29 14.07 27.43 12.5 25.5 12.5H15.5C13.57 12.5 12 14.07 12 16V23.208C12 25.138 13.57 26.708 15.5 26.708H23.217L24.592 28.25ZM24.592 30C24.4509 30.0003 24.3114 29.9707 24.1827 29.9132C24.0539 29.8556 23.9388 29.7713 23.845 29.666L22.545 28.208H15.5C14.1739 28.208 12.9021 27.6812 11.9645 26.7435C11.0268 25.8059 10.5 24.5341 10.5 23.208V16C10.5 14.6739 11.0268 13.4021 11.9645 12.4645C12.9021 11.5268 14.1739 11 15.5 11H25.5C26.8261 11 28.0979 11.5268 29.0355 12.4645C29.9732 13.4021 30.5 14.6739 30.5 16V23.208C30.5 24.31 30.1362 25.3811 29.465 26.255C28.7937 27.129 27.8527 27.7568 26.788 28.041L25.338 29.666C25.2443 29.7712 25.1294 29.8554 25.0008 29.913C24.8722 29.9705 24.7329 30.0002 24.592 30Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.5 11.5H14.5C12.8431 11.5 11.5 12.8431 11.5 14.5V24.5C11.5 26.1569 12.8431 27.5 14.5 27.5H26.5C28.1569 27.5 29.5 26.1569 29.5 24.5V14.5C29.5 12.8431 28.1569 11.5 26.5 11.5Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22.6372 26.4238L24.5622 29.1288L26.6472 26.4238H22.6372Z",
                        fill: "#01A0FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.2151 20.2727H21.3742L22.3457 21.5511L22.6014 21.892L24.0503 23.8182H22.8912L21.9367 22.5398L21.698 22.2159L20.2151 20.2727ZM24.4082 18.6364C24.4082 19.5568 24.2421 20.3523 23.9097 21.0227C23.5773 21.6932 23.1213 22.2102 22.5418 22.5739C21.9622 22.9375 21.3003 23.1193 20.556 23.1193C19.8117 23.1193 19.1497 22.9375 18.5702 22.5739C17.9906 22.2102 17.5347 21.6932 17.2023 21.0227C16.8699 20.3523 16.7037 19.5568 16.7037 18.6364C16.7037 17.7159 16.8699 16.9205 17.2023 16.25C17.5347 15.5795 17.9906 15.0625 18.5702 14.6989C19.1497 14.3352 19.8117 14.1534 20.556 14.1534C21.3003 14.1534 21.9622 14.3352 22.5418 14.6989C23.1213 15.0625 23.5773 15.5795 23.9097 16.25C24.2421 16.9205 24.4082 17.7159 24.4082 18.6364ZM23.3855 18.6364C23.3855 17.8807 23.2591 17.2429 23.0063 16.723C22.7563 16.2031 22.4168 15.8097 21.9878 15.5426C21.5617 15.2756 21.0844 15.142 20.556 15.142C20.0276 15.142 19.5489 15.2756 19.1199 15.5426C18.6938 15.8097 18.3543 16.2031 18.1014 16.723C17.8514 17.2429 17.7264 17.8807 17.7264 18.6364C17.7264 19.392 17.8514 20.0298 18.1014 20.5497C18.3543 21.0696 18.6938 21.4631 19.1199 21.7301C19.5489 21.9972 20.0276 22.1307 20.556 22.1307C21.0844 22.1307 21.5617 21.9972 21.9878 21.7301C22.4168 21.4631 22.7563 21.0696 23.0063 20.5497C23.2591 20.0298 23.3855 19.392 23.3855 18.6364Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_983_155",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "41",
                        height: "41",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var notification_RecommendMentorPostIcon = (RecommendMentorPostIcon);

;// CONCATENATED MODULE: ./src/app.feature/notification/component/NotificationCard/NotificationCard.types.tsx
var NotificationTypes = [
    "ActivityApprovedNotification",
    "ActivityRefusedNotification",
    "NewActivityNotification",
    "BookmarkToNewsItemNotification",
    "CommentToCommentNotification",
    "CommentToPostNotification",
    "FollowToChannelNotification",
    "LikeToNewsItemNotification",
    "NewsCommentToNewsCommentNotification",
    "NewsCommentToNewsItemNotification",
    "NewNewsItemNotification",
    "OrganizationApprovedNotification",
    "OrganizationPendingNotification",
    "ReplyToActivityNotification",
    "ReplyToReplyNotification",
    "ScrapActivityCloseSoonNotification",
    "ScrapActivityCloseSoonerNotification",
    "ChatMessageReplyNotification",
    "AcceptedMentorCommentRewardNotification",
    "CommentToMentorPostNotification",
    "RecommendedMentorPostNotification",
    "MatchedMentorCommentRewardNotification",
    "MentorApprovedNotification"
];

;// CONCATENATED MODULE: ./src/app.feature/notification/component/NotificationCard/NotificationCard.tsx

function NotificationCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment Notification_SimpleNotification on SimpleNotification {\n    id\n    __typename\n    title\n    content\n    unread\n    linkUrl\n    deepLinkUrl\n    createdAt\n  }\n"
    ]);
    NotificationCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 0;\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  &[data-new='true'] {\n    background-color: #f2faff;\n  }\n  .lt-section {\n    cursor: pointer;\n    padding: 0px 28px;\n    display: flex;\n    gap: 16px;\n    .type-ico,\n    .type-text {\n      width: 41px;\n      height: 41px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n      color: white;\n      background-color: #01a0ff;\n    }\n    .type-text {\n      background-color: #01a0ff;\n    }\n\n    .notification-info {\n      .notiinfo-title {\n        .count {\n          color: #01a0ff;\n        }\n      }\n      .notiinfo-desc {\n        font-size: 12px;\n        color: #999;\n        margin-bottom: 7px;\n      }\n      .notiinfo-footer {\n        font-size: 12px;\n        color: #999;\n        .notiinfo-hr {\n          padding: 0px 10px;\n        }\n      }\n    }\n  }\n  .rt-section {\n    padding: 0px 16px;\n    .close-btn {\n      display: flex;\n      cursor: pointer;\n      svg {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















src_default()(NotificationCard_templateObject());
var isNotificationType = function(type) {
    if (NotificationTypes.includes(type)) {
        return true;
    }
    return false;
};
var getTypeData = function(type) {
    if (isNotificationType(type)) {
        switch(type){
            case "ActivityApprovedNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ActivityType, {}),
                    category: "공고"
                };
            case "ActivityRefusedNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ActivityType, {}),
                    category: "공고"
                };
            case "BookmarkToNewsItemNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "CommentToCommentNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_CommunityType, {}),
                    category: "커뮤니티"
                };
            case "CommentToPostNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_CommunityType, {}),
                    category: "커뮤니티"
                };
            case "FollowToChannelNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "LikeToNewsItemNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "NewActivityNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ActivityType, {}),
                    category: "공고"
                };
            case "NewNewsItemNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "NewsCommentToNewsCommentNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "NewsCommentToNewsItemNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "OrganizationApprovedNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "OrganizationPendingNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChannelType, {}),
                    category: "채널"
                };
            case "ReplyToActivityNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ActivityType, {}),
                    category: "공고"
                };
            case "ReplyToReplyNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_CommunityType, {}),
                    category: "커뮤니티"
                };
            case "ScrapActivityCloseSoonNotification":
                return {
                    ico: "D-3",
                    category: "공고"
                };
            case "ScrapActivityCloseSoonerNotification":
                return {
                    ico: "D-1",
                    category: "공고"
                };
            case "ChatMessageReplyNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_ChatReplyMessageType, {}),
                    category: "채팅"
                };
            case "AcceptedMentorCommentRewardNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_MentorRewardIcon, {}),
                    category: "커뮤니티"
                };
            case "MatchedMentorCommentRewardNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_MentorRewardIcon, {}),
                    category: "커뮤니티"
                };
            case "CommentToMentorPostNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_CommentMentorPostIcon, {}),
                    category: "커뮤니티"
                };
            case "RecommendedMentorPostNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_RecommendMentorPostIcon, {}),
                    category: "커뮤니티"
                };
            case "MentorApprovedNotification":
                return {
                    ico: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_MentorApproveIcon, {}),
                    category: "커뮤니티"
                };
        }
    }
    return {
        ico: "",
        category: ""
    };
};
var NotificationCard = function(param) {
    var data = param.data, onClick = param.onClick, onClickDelete = param.onClickDelete;
    var router = (0,next_router.useRouter)();
    var typeData = getTypeData(data.__typename);
    var handleClickNotification = function(data) {
        onClick(data.id);
        if ((data === null || data === void 0 ? void 0 : data.__typename) === "ChatMessageReplyNotification") {
            router.replace("".concat(router.asPath).concat(router.query.tab ? "&" : "?").concat(data.linkUrl.split("?")[1]));
        } else {
            router.push(data.linkUrl);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationCard_StyledWrapper, {
        "data-new": data.unread,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt-section",
                onClick: function() {
                    return handleClickNotification(data);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: typeof typeData.ico === "string" ? "type-text" : "type-ico",
                        children: typeData.ico
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "notification-info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "notiinfo-title",
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "notiinfo-desc",
                                children: data.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "notiinfo-footer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: typeData.category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "notiinfo-hr",
                                        children: "|"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,time/* convertCreatedAtToString */.Ui)(data.createdAt)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt-section",
                onClick: function() {
                    return onClickDelete(data.id);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                })
            })
        ]
    });
};
/* harmony default export */ var NotificationCard_NotificationCard = (NotificationCard);
var NotificationCard_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotificationCard__StyledWrapper",
    componentId: "sc-5ac6245f-0"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/notification/component/NotificationCard/NotificationCardLoading.tsx

function NotificationCardLoading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 0;\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  height: 96.5px;\n  .lt-section {\n    padding: 0px 28px;\n    display: flex;\n    gap: 16px;\n    .type-ico {\n      width: 41px;\n      height: 41px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n      background-color: #eee;\n    }\n    .notification-info {\n      .notiinfo-title {\n        width: 100px;\n        height: 15px;\n        background-color: #eee;\n        margin-bottom: 3px;\n        border-radius: 5px;\n      }\n      .notiinfo-desc {\n        width: 300px;\n        height: 12px;\n        background-color: #eee;\n        margin-bottom: 3px;\n        border-radius: 5px;\n      }\n      .notiinfo-footer {\n        display: flex;\n        gap: 10px;\n        div {\n          width: 50px;\n          height: 10px;\n          background-color: #eee;\n          border-radius: 5px;\n        }\n      }\n    }\n  }\n  .rt-section {\n    padding: 0px 16px;\n    .close-btn {\n      display: flex;\n      cursor: pointer;\n      svg {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n"
    ]);
    NotificationCardLoading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NotificationCardLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationCardLoading_StyledWrapper, {
        className: "new",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "type-ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "notification-info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "notiinfo-title"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "notiinfo-desc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "notiinfo-footer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                })
            })
        ]
    });
};
/* harmony default export */ var NotificationCard_NotificationCardLoading = (NotificationCardLoading);
var NotificationCardLoading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotificationCardLoading__StyledWrapper",
    componentId: "sc-ffa105a5-0"
})(NotificationCardLoading_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/notification/component/NotificationCard/NotificationCardMobile.tsx

function NotificationCardMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e8e8e8;\n  background-color: white;\n  &[data-unread='true'] {\n    background-color: #f2faff;\n    .lt {\n      .dot {\n        &::after {\n          background-color: #01a0ff;\n        }\n      }\n    }\n  }\n  .lt {\n    overflow: hidden;\n    display: flex;\n    cursor: pointer;\n    .dot {\n      height: 24px;\n      display: flex;\n      align-items: center;\n      margin-right: 10px;\n      &::after {\n        content: '';\n        width: 9px;\n        height: 9px;\n        border-radius: 50%;\n        background-color: #003056;\n      }\n    }\n    .content {\n      .noti-title {\n        font-size: 16px;\n        line-height: 24px;\n      }\n      .noti-subtitle {\n        font-size: 16px;\n        color: #999;\n        margin-bottom: 5px;\n        word-break: break-word;\n      }\n      .noti-desc {\n        font-size: 12px;\n        color: #999;\n        span {\n          padding: 0px 7px;\n        }\n      }\n    }\n  }\n  .rt {\n    display: flex;\n    align-items: center;\n    height: 24px;\n    cursor: pointer;\n  }\n"
    ]);
    NotificationCardMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var NotificationCardMobile = function(param) {
    var data = param.data, onClick = param.onClick, onClickDelete = param.onClickDelete;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var typeData = getTypeData(data.__typename);
    var ref = (0,react.useState)(false), isAppModalOpen = ref[0], setIsAppModalOpen = ref[1];
    var handleClickNotification = function(data) {
        onClick(data.id);
        if ((data === null || data === void 0 ? void 0 : data.__typename) === "ChatMessageReplyNotification") {
            isWebview ? router.push("/?".concat(data === null || data === void 0 ? void 0 : data.linkUrl.split("?")[1])) : setIsAppModalOpen(true);
        } else {
            router.push(data.linkUrl);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationCardMobile_StyledWrapper, {
        "data-unread": data.unread,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt",
                onClick: function() {
                    return handleClickNotification(data);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dot"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "noti-title",
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "noti-subtitle",
                                children: data.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "noti-desc",
                                children: [
                                    typeData.category,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "|"
                                    }),
                                    (0,time/* convertCreatedAtToString */.Ui)(data.createdAt)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt",
                onClick: function() {
                    return onClickDelete(data.id);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatAppModal/* default */.Z, {
                open: isAppModalOpen,
                onClose: function() {
                    return setIsAppModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var NotificationCard_NotificationCardMobile = (NotificationCardMobile);
var NotificationCardMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotificationCardMobile__StyledWrapper",
    componentId: "sc-d93f0a14-0"
})(NotificationCardMobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/notification/component/NotificationCard/NotificationCardMobileLoading.tsx

function NotificationCardMobileLoading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e8e8e8;\n  background-color: white;\n  .lt {\n    display: flex;\n\n    .dot {\n      height: 24px;\n      display: flex;\n      align-items: center;\n      margin-right: 10px;\n      &::after {\n        content: '';\n        width: 9px;\n        height: 9px;\n        border-radius: 50%;\n        background-color: #eee;\n        border-radius: 5px;\n      }\n    }\n    .content {\n      .noti-title {\n        width: 100px;\n        height: 24px;\n        background-color: #eee;\n        border-radius: 5px;\n        margin-bottom: 3px;\n      }\n      .noti-subtitle {\n        width: 300px;\n        height: 22px;\n        background-color: #eee;\n        border-radius: 5px;\n        margin-bottom: 3px;\n      }\n      .noti-desc {\n        display: flex;\n        gap: 10px;\n        div {\n          width: 50px;\n          height: 17px;\n          background-color: #eee;\n          border-radius: 5px;\n        }\n      }\n    }\n  }\n  .rt {\n    display: flex;\n    align-items: center;\n    height: 24px;\n  }\n"
    ]);
    NotificationCardMobileLoading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var NotificationCardMobileLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationCardMobileLoading_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dot"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "noti-title"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "noti-subtitle"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "noti-desc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt"
            })
        ]
    });
};
/* harmony default export */ var NotificationCard_NotificationCardMobileLoading = (NotificationCardMobileLoading);
var NotificationCardMobileLoading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotificationCardMobileLoading__StyledWrapper",
    componentId: "sc-675dfff-0"
})(NotificationCardMobileLoading_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/notification/component/NotificationCard/index.tsx





/* harmony default export */ var component_NotificationCard = (NotificationCard_NotificationCard);

;// CONCATENATED MODULE: ./src/app.feature/notification/screen/ScreenNotificationPage.desktop.tsx

function ScreenNotificationPage_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .noti-title {\n    font-size: 26px;\n    font-weight: 700;\n    margin-bottom: 30px;\n  }\n  .noti-tabs {\n    margin-bottom: 16px;\n  }\n\n  .tool-bar {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 12px;\n    .delete-btn {\n      border: 1px solid #dedede;\n      color: #666666;\n      padding: 11px 17px;\n      &:hover {\n        border: 1px solid #999999;\n      }\n    }\n  }\n  .noti-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 30px;\n  }\n"
    ]);
    ScreenNotificationPage_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ScreenNotificationDesktop = function(param) {
    var tabs = param.tabs, className = param.className, query = param.query, onClickNotification = param.onClickNotification, handleClickDeleteNotification = param.handleClickDeleteNotification, handleClickDeleteAll = param.handleClickDeleteAll;
    var ref, ref1, ref2, ref3;
    var data = query.data, loading = query.loading, error = query.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenNotificationPage_desktop_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "noti-title",
                children: "알림"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTabs/* default */.Z, {
                className: "noti-tabs",
                data: tabs,
                initialTab: tabs[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tool-bar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "grey",
                    variant: "outlined",
                    className: "delete-btn",
                    onClick: handleClickDeleteAll,
                    children: "모두삭제"
                })
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "noti-list",
                children: new Array(10).fill("").map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCard_NotificationCardLoading, {}, idx);
                })
            }),
            !data || error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "noti-list",
                children: new Array(5).fill("").map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCard_NotificationCardLoading, {}, idx);
                })
            }),
            !loading && data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "noti-list",
                        children: [
                            ((ref = data.viewerNotifications) === null || ref === void 0 ? void 0 : ref.nodes.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotification_EmptyNotification, {}),
                            (ref1 = data.viewerNotifications) === null || ref1 === void 0 ? void 0 : ref1.nodes.map(function(notification, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_NotificationCard, {
                                    data: notification,
                                    onClick: onClickNotification,
                                    onClickDelete: handleClickDeleteNotification
                                }, idx);
                            })
                        ]
                    }),
                    ((ref2 = data.viewerNotifications) === null || ref2 === void 0 ? void 0 : ref2.nodes.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        totalCount: (ref3 = data.viewerNotifications) === null || ref3 === void 0 ? void 0 : ref3.totalCount,
                        pageSize: 20,
                        stepSize: 10,
                        scrollTop: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenNotificationPage_desktop = (ScreenNotificationDesktop);
var ScreenNotificationPage_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenNotificationPage.desktop__StyledWrapper",
    componentId: "sc-9c3fa4e7-0"
})(ScreenNotificationPage_desktop_templateObject());

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/app.feature/notification/component/EmptyNotification/index.tsx


;// CONCATENATED MODULE: ./src/app.feature/notification/screen/ScreenNotificationPage.mobile.tsx

function ScreenNotificationPage_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .noti-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 13px 20px;\n    border-bottom: 1px solid #e8e8e8;\n    background-color: white;\n    .noti-title {\n      font-size: 16px;\n      font-weight: bold;\n    }\n    .delete-btn {\n      font-size: 14px;\n    }\n  }\n  .noti-navbar {\n    display: flex;\n    gap: 15px;\n    padding: 13px 20px;\n    border-bottom: 1px solid #e8e8e8;\n    background-color: #fafafa;\n    .menu {\n      color: #999;\n      &[data-active='true'] {\n        color: black;\n      }\n    }\n  }\n  .noti-list {\n  }\n  .webview-pagination {\n    padding: 20px 0px 70px;\n  }\n  .pagination {\n    padding: 20px 0;\n  }\n"
    ]);
    ScreenNotificationPage_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ScreenNotificationMobile = function(param) {
    var className = param.className, selectedMenu = param.selectedMenu, tabs = param.tabs, query = param.query, onClickNotification = param.onClickNotification, handleClickDeleteNotification = param.handleClickDeleteNotification, handleClickDeleteAll = param.handleClickDeleteAll;
    var ref, ref1, ref2, ref3;
    var isWebview = (0,useIsWebview/* default */.Z)();
    var data = query.data, loading = query.loading, error = query.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenNotificationPage_mobile_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "noti-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "noti-title",
                        children: "알림"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "delete-btn",
                        onClick: handleClickDeleteAll,
                        children: "모두삭제"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "noti-navbar",
                children: tabs.map(function(tabs, idx) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                        href: tabs.href || "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "menu",
                            "data-active": selectedMenu === ((ref = tabs.href) === null || ref === void 0 ? void 0 : ref.query.tab),
                            children: [
                                tabs.name,
                                " ",
                                "(".concat(tabs.count || 0, ")")
                            ]
                        })
                    }, idx);
                })
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "noti-list",
                children: new Array(10).fill("").map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCard_NotificationCardMobileLoading, {}, idx);
                })
            }),
            !data || error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "error"
            }),
            !loading && data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "noti-list",
                        children: [
                            ((ref = data.viewerNotifications) === null || ref === void 0 ? void 0 : ref.nodes.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotification_EmptyNotification, {}),
                            (ref1 = data.viewerNotifications) === null || ref1 === void 0 ? void 0 : ref1.nodes.map(function(notification, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCard_NotificationCardMobile, {
                                    data: notification,
                                    onClick: onClickNotification,
                                    onClickDelete: handleClickDeleteNotification
                                }, idx);
                            })
                        ]
                    }),
                    ((ref2 = data.viewerNotifications) === null || ref2 === void 0 ? void 0 : ref2.nodes.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        className: isWebview ? "webview-pagination" : "pagination",
                        totalCount: (ref3 = data.viewerNotifications) === null || ref3 === void 0 ? void 0 : ref3.totalCount,
                        pageSize: 20,
                        stepSize: 5
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenNotificationPage_mobile = (ScreenNotificationMobile);
var ScreenNotificationPage_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenNotificationPage.mobile__StyledWrapper",
    componentId: "sc-8a582cc-0"
})(ScreenNotificationPage_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/notification/screen/ScreenNotificationPage.types.tsx

var menuToScope = {
    all: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION,
    activity: graphql/* NotificationScope.ACTIVITY_NOTIFICATION */.Bm0.ACTIVITY_NOTIFICATION,
    channel: graphql/* NotificationScope.CHANNEL_NOTIFICATION */.Bm0.CHANNEL_NOTIFICATION,
    community: graphql/* NotificationScope.COMMUNITY_NOTIFICATION */.Bm0.COMMUNITY_NOTIFICATION,
    chat: graphql/* NotificationScope.CHAT_NOTIFICATION */.Bm0.CHAT_NOTIFICATION
};

;// CONCATENATED MODULE: ./src/app.feature/notification/screen/ScreenNotificationPage.tsx


function ScreenNotificationPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlScreenNotificationPage(\n    $allFilterBy: NotificationsFilter\n    $activityFilterBy: NotificationsFilter\n    $channelFilterBy: NotificationsFilter\n    $communityFilterBy: NotificationsFilter\n    $chatFilterBy: NotificationsFilter\n  ) {\n    all: viewerNotifications(filterBy: $allFilterBy) {\n      totalCount\n    }\n    activity: viewerNotifications(filterBy: $activityFilterBy) {\n      totalCount\n    }\n    channel: viewerNotifications(filterBy: $channelFilterBy) {\n      totalCount\n    }\n    community: viewerNotifications(filterBy: $communityFilterBy) {\n      totalCount\n    }\n    chat: viewerNotifications(filterBy: $chatFilterBy) {\n      totalCount\n    }\n  }\n  query gqlNotificationList(\n    $filterBy: NotificationsFilter\n    $pagination: Pagination\n  ) {\n    viewerNotifications(filterBy: $filterBy, pagination: $pagination) {\n      nodes {\n        ...Notification_SimpleNotification\n      }\n      totalCount\n    }\n  }\n"
    ]);
    ScreenNotificationPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScreenNotificationPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1148px;\n  margin: 0 auto;\n  padding: 50px 24px;\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    ScreenNotificationPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














src_default()(ScreenNotificationPage_templateObject());
var ScreenNotificationPage = function() {
    var ref, ref1, ref2, ref3, ref4;
    // hooks
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    var screenNotificationQueryVariables = {
        allFilterBy: {
            scope: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
        },
        activityFilterBy: {
            scope: graphql/* NotificationScope.ACTIVITY_NOTIFICATION */.Bm0.ACTIVITY_NOTIFICATION
        },
        channelFilterBy: {
            scope: graphql/* NotificationScope.CHANNEL_NOTIFICATION */.Bm0.CHANNEL_NOTIFICATION
        },
        communityFilterBy: {
            scope: graphql/* NotificationScope.COMMUNITY_NOTIFICATION */.Bm0.COMMUNITY_NOTIFICATION
        },
        chatFilterBy: {
            scope: graphql/* NotificationScope.CHAT_NOTIFICATION */.Bm0.CHAT_NOTIFICATION
        }
    };
    // quries
    var data = (0,graphql/* useGqlScreenNotificationPageQuery */.MR)({
        variables: screenNotificationQueryVariables
    }).data;
    // mutations
    var readMutation = (0,graphql/* useReadNotificationMutation */.ZNI)({
        refetchQueries: [
            {
                query: graphql/* PageLayoutDocument */.TbJ,
                variables: {
                    notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                }
            }, 
        ]
    });
    var deleteMutation = (0,graphql/* useDeleteNotificationMutation */.sJ3)({
        refetchQueries: [
            {
                query: graphql/* PageLayoutDocument */.TbJ,
                variables: {
                    notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                }
            }, 
        ]
    });
    var deleteAllMutation = (0,graphql/* useDeleteAllNotificationMutation */.TT3)({
        refetchQueries: [
            {
                query: graphql/* PageLayoutDocument */.TbJ,
                variables: {
                    notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                }
            }, 
        ]
    });
    var selectedMenu = router.query.tab || "all";
    var tabs = [
        {
            id: 0,
            name: "전체",
            count: data === null || data === void 0 ? void 0 : (ref = data.all) === null || ref === void 0 ? void 0 : ref.totalCount,
            href: {
                query: {
                    tab: "all"
                }
            }
        },
        {
            id: 1,
            name: "공고",
            count: data === null || data === void 0 ? void 0 : (ref1 = data.activity) === null || ref1 === void 0 ? void 0 : ref1.totalCount,
            href: {
                query: {
                    tab: "activity"
                }
            }
        },
        {
            id: 2,
            name: "채널",
            count: data === null || data === void 0 ? void 0 : (ref2 = data.channel) === null || ref2 === void 0 ? void 0 : ref2.totalCount,
            href: {
                query: {
                    tab: "channel"
                }
            }
        },
        {
            id: 3,
            name: "커뮤니티",
            count: data === null || data === void 0 ? void 0 : (ref3 = data.community) === null || ref3 === void 0 ? void 0 : ref3.totalCount,
            href: {
                query: {
                    tab: "community"
                }
            }
        },
        {
            id: 4,
            name: "채팅",
            count: data === null || data === void 0 ? void 0 : (ref4 = data.chat) === null || ref4 === void 0 ? void 0 : ref4.totalCount,
            href: {
                query: {
                    tab: "chat"
                }
            }
        }, 
    ];
    var currentPage = router.query.page ? +router.query.page : 1;
    var notificationListQueryVariables = {
        filterBy: {
            scope: menuToScope[selectedMenu]
        },
        pagination: {
            page: currentPage,
            pageSize: 20
        }
    };
    var query = (0,graphql/* useGqlNotificationListQuery */.WGY)({
        variables: notificationListQueryVariables,
        fetchPolicy: "cache-and-network"
    });
    var handleReadNotification = function(id) {
        var _readMutation = (0,_sliced_to_array/* default */.Z)(readMutation, 1), mutate = _readMutation[0];
        mutate({
            variables: {
                readNotificationId: id
            },
            onCompleted: function() {
                if (isWebview) {
                    fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportReadNotification");
                }
            }
        });
    };
    var handleClickDeleteNotification = function(id) {
        var _deleteMutation = (0,_sliced_to_array/* default */.Z)(deleteMutation, 1), mutate = _deleteMutation[0];
        mutate({
            variables: {
                deleteNotificationId: id
            },
            update: removeScrap(notificationListQueryVariables),
            refetchQueries: [
                {
                    query: graphql/* GqlScreenNotificationPageDocument */._EX,
                    variables: screenNotificationQueryVariables
                }, 
            ],
            onCompleted: function() {
                if (isWebview) {
                    fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveNotification");
                }
            }
        });
    };
    var handleClickDeleteAll = function() {
        var _deleteAllMutation = (0,_sliced_to_array/* default */.Z)(deleteAllMutation, 1), mutate = _deleteAllMutation[0];
        mutate({
            variables: {
                scope: menuToScope[selectedMenu]
            },
            update: removeAllScrap(notificationListQueryVariables),
            refetchQueries: [
                {
                    query: graphql/* GqlScreenNotificationPageDocument */._EX,
                    variables: screenNotificationQueryVariables
                }, 
            ],
            onCompleted: function() {
                if (isWebview) {
                    fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveAllNotifications");
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNotificationPage_StyledWrapper, {
        className: "noti-container",
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNotificationPage_mobile, {
            tabs: tabs,
            className: "mobile noti-container",
            selectedMenu: selectedMenu,
            query: query,
            onClickNotification: handleReadNotification,
            handleClickDeleteNotification: handleClickDeleteNotification,
            handleClickDeleteAll: handleClickDeleteAll
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNotificationPage_desktop, {
            tabs: tabs,
            className: "desktop noti-container",
            selectedMenu: selectedMenu,
            query: query,
            onClickNotification: handleReadNotification,
            handleClickDeleteNotification: handleClickDeleteNotification,
            handleClickDeleteAll: handleClickDeleteAll
        })
    });
};
/* harmony default export */ var screen_ScreenNotificationPage = (ScreenNotificationPage);
var ScreenNotificationPage_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenNotificationPage__StyledWrapper",
    componentId: "sc-d91c14ae-0"
})(ScreenNotificationPage_templateObject1(), media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 50516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68250);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27963);


var useIsMobile = function() {
    var matches = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("(max-width: ".concat(app_styled_media__WEBPACK_IMPORTED_MODULE_0__/* .mobileBreakPointSize */ .Zq, "px)"));
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 27963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * React hook to evaluate a CSS media query and return whether it matches.
 *
 * Usage example:
 *   const isDesktop = useMediaQuery('(min-width: 960px)')
 *
 * @param query - A valid CSS media query string
 *   e.g. '(min-width: 960px)', '(max-width: 600px)'
 *
 * @param defaultMatches - Initial match value used during SSR (server-side rendering).
 *   - SSR에서는 `window.matchMedia`를 사용할 수 없으므로 기본값을 사용합니다.
 *   - 기본값은 false이며, 필요하다면 UA 기반으로 true/false를 전달할 수 있습니다.
 *   - 예: `useMediaQuery('(min-width: 960px)', { defaultMatches: isDesktopUA })`
 *
 * ⚠️ 주의
 * - query에는 반드시 완전한 미디어 문자열(@media 없이)만 넣어야 합니다.
 *   예: "tabletBreakPoint" 같은 상수가 있다면, 실제 문자열 "(min-width: 960px)" 형태로 전달해야 합니다.
 * - defaultMatches는 선택값이며, SSR 환경에서 깜빡임(mismatch)을 줄이려면
 *   UA(user agent) 기반 값을 넘겨주는 것이 좋습니다.
 */ var useMediaQuery = function(query) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _defaultMatches = ref.defaultMatches, defaultMatches = _defaultMatches === void 0 ? false : _defaultMatches;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultMatches), matches = ref1[0], setMatches = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mql = window.matchMedia(query);
        var onChange = function() {
            setMatches(mql.matches);
        };
        onChange();
        if (mql.addEventListener) {
            mql.addEventListener("change", onChange);
        } else {
            // Safari < 14 fallback
            mql.addListener(onChange);
        }
        return function() {
            if (mql.removeEventListener) {
                mql.removeEventListener("change", onChange);
            } else {
                mql.removeListener(onChange);
            }
        };
    }, [
        query
    ]);
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ }),

/***/ 20178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ui": function() { return /* binding */ convertCreatedAtToString; },
/* harmony export */   "ax": function() { return /* binding */ formatRemainingTimeToString; }
/* harmony export */ });
/* unused harmony export getRemainingTime */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23311);
/* harmony import */ var date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76972);
/* harmony import */ var date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69690);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32912);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42699);
/* harmony import */ var date_fns_subDays__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7069);
/* harmony import */ var date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81289);
/* harmony import */ var date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88619);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);










var convertCreatedAtToString = function(createdAt) {
    var NOW = new Date();
    var ONE_MINUTE_AGO = (0,date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NOW, 1);
    var ONE_HOUR_AGO = (0,date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NOW, 1);
    var ONE_DAY_AGO = (0,date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NOW, 24);
    var ONE_WEEK_AGO = (0,date_fns_subDays__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(NOW, 7);
    var writenInOneMunite = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_MINUTE_AGO);
    var writenInOneHour = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_HOUR_AGO);
    var writenInOneDay = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_DAY_AGO);
    var writenInOneWeek = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_WEEK_AGO);
    if (writenInOneMunite) {
        return "방금 전";
    }
    if (writenInOneHour) {
        return "".concat((0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(NOW, createdAt), "분 전");
    }
    if (writenInOneDay) {
        return "".concat((0,date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(NOW, createdAt), "시간 전");
    }
    if (writenInOneWeek) {
        return "".concat((0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(NOW, createdAt), "일 전");
    }
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(createdAt, "yyyy.MM.dd");
};
var getRemainingTime = function(date) {
    var nowDate = new Date();
    return (0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(date, nowDate.getTime());
};
var formatRemainingTimeToString = function(closedAt, recruitType) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "CoverLetterTitle", isOnlyDate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    switch(recruitType){
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.ALWAYS */ .iS2.ALWAYS:
            return "상시채용";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.ASAP */ .iS2.ASAP:
            return "채용 시 마감";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.SCHEDULED */ .iS2.SCHEDULED:
            return "예정";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.NORMAL */ .iS2.NORMAL:
            if (closedAt) {
                var dDay = getRemainingTime(closedAt);
                if (dDay === 0) {
                    var hours = (0,date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(closedAt, new Date());
                    if (hours === 0) {
                        var minutes = (0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(closedAt, new Date());
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            style: {
                                color: "#ff0000"
                            },
                            children: [
                                minutes,
                                "분 남음"
                            ]
                        });
                    }
                    if (hours < 0) {
                        if (type === "DutyItem") return "마감";
                        return "D+".concat(Math.abs(hours), "시");
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        style: {
                            color: "#ff0000"
                        },
                        children: [
                            hours,
                            "시간 남음"
                        ]
                    });
                }
                if (dDay < 0) {
                    if (type === "DutyItem") return "마감";
                    return "D+".concat(Math.abs(dDay) > 999 ? 999 : Math.abs(dDay)).concat(isOnlyDate ? "" : "일");
                }
                return "D-".concat(dDay > 999 ? 999 : dDay).concat(isOnlyDate ? "" : "일");
            }
            return "마감일 없음";
        default:
            return "마감일 없음";
    }
};


/***/ }),

/***/ 44191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);
/* harmony import */ var _useCurrentUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38405);




function useAuthRoute(props) {
    var _role = props.role, role = _role === void 0 ? "user" : _role, _redirectPath = props.redirectPath, redirectPath = _redirectPath === void 0 ? "/" : _redirectPath, _showAlert = props.showAlert, showAlert = _showAlert === void 0 ? true : _showAlert, _skip = props.skip, skip = _skip === void 0 ? false : _skip;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), pass = ref[0], setPass = ref[1];
    var ref1 = (0,_useCurrentUser__WEBPACK_IMPORTED_MODULE_3__/* .useCurrentUserContext */ .O)(), user = ref1.user, loading = ref1.loading, error = ref1.error;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var redirect = function redirect(path) {
            if (path === "/") {
                window.location.href = "/";
                return;
            }
            router.replace(path);
        };
        if ( false || pass || loading || error || skip) return;
        if (user === null || user === void 0 ? void 0 : user.isSuperuser) {
            setPass(true);
            return;
        }
        if (role === "user" && !user) {
            if (showAlert) {
                alert("로그인 후 이용할 수 있습니다");
            }
            redirect(redirectPath);
            return;
        }
        if (role === "organization" && (user === null || user === void 0 ? void 0 : user.type) !== generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .UserType.MANAGER_UNVERIFIED */ .FWD.MANAGER_UNVERIFIED) {
            if (showAlert) {
                alert("기업회원만 이용할 수 있습니다");
            }
            redirect(redirectPath);
            return;
        }
        if (role === "admin" && !(user === null || user === void 0 ? void 0 : user.isSuperuser)) {
            if (showAlert) {
                alert("접근 권한이 없습니다");
            }
            redirect(redirectPath);
            return;
        }
        setPass(true);
    }, [
        role,
        redirectPath,
        pass,
        loading,
        error,
        user,
        showAlert,
        skip,
        router
    ]);
    return {
        pass: pass
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useAuthRoute);


/***/ })

}]);